import { useEffect, useRef } from 'react';

export const usePreservedData = <T>(isLoading: boolean, newData: T) => {
  const prevDataRef = useRef<T>(newData);

  useEffect(() => {
    if (isLoading) return;
    prevDataRef.current = newData;
  }, [isLoading, newData]);

  return isLoading ? prevDataRef.current : newData;
};
